import React from "react";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";

const TestiCardWeb = ({ review }) => {
  return (
    <div className="bg-white border border-gray-200 shadow-md flex flex-col items-center p-6 rounded-lg">
      {/* Image Section */}
      <div className="relative mb-4">
        <img
          className="w-28 h-28 rounded-full border-4 border-violet-500"
          alt="Reviewer"
          src={"/assets/" + review.image}
        />

        <div className="absolute -bottom-2 left-2 w-full h-full bg-violet-300 rounded-full opacity-50 -z-10"></div>
      </div>

      {/* Text Content */}
      <div className="text-center">
        <p className="font-bold text-xl capitalize">{review.name}</p>
        <p className="text-violet-400 uppercase text-sm">{review.job}</p>
      </div>

      {/* Review Text */}
      <div className="text-center text-slate-500 mt-4 px-3">
        <FaQuoteLeft className="text-violet-400 inline-block mb-2" />
        <p className="italic" style={{ textAlign: "justify" }}>
          {review.text}
        </p>
        <FaQuoteRight className="text-violet-400 inline-block mt-2" />
      </div>
    </div>
  );
};

export default TestiCardWeb;


export const TestiCardMobile = (props) => {
  let review = props.review;
return (
  <div className='flex !pt-[35px] md:pt-0 flex-col md:relative '>
    <div className='absolute !top-[-4rem] left-[30%] z-[10] mx-auto'>
      <img 
      className="aspect-square rounded-full bg-richblue-5 !w-[140px] !h-[140px] !z-[25]"
      alt=''
      src={"/assets/"+review.image}
      />
      <div className='w-[140px] !h-[100px] bg-violet-500 rounded-full absolute
       !top-[-6px] !z-[-10] !left-[10px]'></div>
    </div>
    
    <div className='text-center !mt-7'>
      <p className='tracking-wider !font-bold !text-2xl !capitalize'>{review.name}</p>
      <p className='!text-violet-300 !uppercase !text-sm'>{review.job}</p>
    </div>


    {/* <div className='text-violet-400 mx-auto mt-5'>
      <FaQuoteLeft/>
    </div> */}

    <div className='mt-4 text-slate-500 text-justify'>
      {review.text}
    </div>

    {/* <div  className='text-violet-400 mx-auto mt-5'>
      <FaQuoteRight/>
    </div> */}
  </div>
)
}
